module.exports = __webpack_public_path__ + "static/logo@2x-e72ca6f03000a559bf360e3df8be9b0c.png";